var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.editId ? 'Edit Slider' : 'Add Slider'))]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("New Slider")])], 1), _vm.errorMessage ? _c('div', {
    staticClass: "alert alert-danger py-1"
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e(), _vm.validationErrors.length ? _c('div', {
    staticClass: "alert alert-danger py-1"
  }, [_c('ul', {
    staticClass: "mb-0 pl-2"
  }, _vm._l(_vm.validationErrors, function (err, index) {
    return _c('li', {
      key: index
    }, [_vm._v(" " + _vm._s(err) + " ")]);
  }), 0)]) : _vm._e(), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Title"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Slider title"
    },
    model: {
      value: _vm.form.title,
      callback: function ($$v) {
        _vm.$set(_vm.form, "title", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.title"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Subtitle"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Slider subtitle"
    },
    model: {
      value: _vm.form.subtitle,
      callback: function ($$v) {
        _vm.$set(_vm.form, "subtitle", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.subtitle"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Button Text"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Shop Now"
    },
    model: {
      value: _vm.form.button_text,
      callback: function ($$v) {
        _vm.$set(_vm.form, "button_text", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.button_text"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Button Link"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "/shop"
    },
    model: {
      value: _vm.form.button_link,
      callback: function ($$v) {
        _vm.$set(_vm.form, "button_link", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.button_link"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sort Order"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.form.sort_order,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sort_order", _vm._n($$v));
      },
      expression: "form.sort_order"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.editId ? 'Image (optional on edit)' : 'Image'
    }
  }, [_c('b-form-file', {
    attrs: {
      "accept": "image/*",
      "placeholder": "Choose image",
      "drop-placeholder": "Drop image here"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('div', {
    staticClass: "mt-1 d-flex flex-wrap"
  }, [_c('b-button', {
    staticClass: "mr-50 mb-50",
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        _vm.showMediaPicker = true;
      }
    }
  }, [_vm._v(" Insert from Media ")]), _c('small', {
    staticClass: "text-muted align-self-center mb-50"
  }, [_vm._v("Upload or reuse existing media")])], 1)], 1)], 1), _vm.imagePreview || _vm.selectedLibraryMedia ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mb-2 d-flex align-items-start flex-wrap"
  }, [_c('div', {
    staticClass: "position-relative mr-1 mb-1"
  }, [_c('img', {
    staticStyle: {
      "width": "180px",
      "height": "110px",
      "object-fit": "cover",
      "border-radius": "8px",
      "border": "1px solid #ddd"
    },
    attrs: {
      "src": _vm.selectedLibraryMedia ? _vm.selectedLibraryMedia.preview_url || _vm.selectedLibraryMedia.original_url : _vm.imagePreview,
      "alt": "Slider preview"
    }
  }), _vm.selectedLibraryMedia ? _c('b-button', {
    staticClass: "slider-remove-chip",
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.clearSelectedLibraryMedia
    }
  }, [_vm._v(" × ")]) : _vm._e()], 1)])]) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.saving
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? 'Saving...' : _vm.editId ? 'Update Slider' : 'Save Slider') + " ")]), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)], 1), _c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v("Slider List")])]), _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "line-numbers": true,
      "search-options": {
        enabled: true
      },
      "pagination-options": {
        enabled: true,
        perPage: 10
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (props) {
        return [props.column.field === 'image' ? _c('span', [props.row.image ? _c('img', {
          staticStyle: {
            "width": "90px",
            "height": "55px",
            "object-fit": "cover",
            "border-radius": "6px"
          },
          attrs: {
            "src": props.row.image,
            "alt": "Slider image"
          }
        }) : _c('span', [_vm._v("No image")])]) : props.column.field === 'status' ? _c('span', [_c('b-badge', {
          attrs: {
            "variant": props.row.status ? 'success' : 'secondary'
          }
        }, [_vm._v(" " + _vm._s(props.row.status ? 'Active' : 'Inactive') + " ")])], 1) : props.column.field === 'action' ? _c('span', [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function ($event) {
              return _vm.openEdit(props.row);
            }
          }
        }, [_vm._v(" Edit ")]), _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-warning"
          },
          on: {
            "click": function ($event) {
              return _vm.toggleStatus(props.row);
            }
          }
        }, [_vm._v(" " + _vm._s(props.row.status ? 'Disable' : 'Enable') + " ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteItem(props.row.id);
            }
          }
        }, [_vm._v(" Delete ")])], 1) : _c('span', [_vm._v(" " + _vm._s(props.row[props.column.field]) + " ")])];
      }
    }])
  })], 1), _c('MediaPickerModal', {
    attrs: {
      "visible": _vm.showMediaPicker,
      "multiple": false,
      "preselected": _vm.selectedLibraryMedia ? [_vm.selectedLibraryMedia] : [],
      "title": "Insert Slider Image",
      "confirm-button-text": "Insert Selected Image"
    },
    on: {
      "close": function ($event) {
        _vm.showMediaPicker = false;
      },
      "select": _vm.handleSliderMediaInsert,
      "insert": _vm.handleSliderMediaInsert
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }